module.exports = __webpack_public_path__ + "img/c57539800c182f73e62a8d564bd44f06.afe36056.png";